
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 10a7 7 0 11-14 0 7 7 0 0114 0zm1 0a8 8 0 11-16 0 8 8 0 0116 0zM6.53 6.53a.5.5 0 01.706 0L10 9.292l2.764-2.764a.5.5 0 01.707.707L10.707 10l2.764 2.764a.5.5 0 01-.707.707L10 10.707l-2.764 2.764a.5.5 0 01-.707-.707L9.293 10 6.529 7.236a.5.5 0 010-.707z","fill":"#303133"}})])
          )
        }
      }
    